import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import { GrowlerMap } from "./components/growlermap";
import { BlogList } from "./components/blog/BlogList";
import { BlogPost } from "./components/blog/BlogPost";
import { BrewerySignup } from './components/brewerysignup';
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const HomePage = ({ landingPageData }) => (
  <>
    <Header data={landingPageData.Header} />
    <Features data={landingPageData.Features} />
    <About data={landingPageData.About} />
    <Services data={landingPageData.Services} />
    <Team data={landingPageData.Team} />
    <Contact data={landingPageData.Contact} />
  </>
);

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <Navigation />
      <Routes>
        <Route path="/" element={<HomePage landingPageData={landingPageData} />} />
        <Route path="/map" element={<GrowlerMap />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route 
          path="/brewery/signup" 
          element={<BrewerySignup />} 
        />
      </Routes>
    </Router>
  );
};

export default App;
